import { Entrada } from '../../componentes/ui.jsx';

/**
 * Jornada do profissional: varias faixas por dia, cada uma dizendo para quem
 * vale.
 *
 *   Convenio   -> ordem de chegada a partir do inicio da faixa (Hapvida)
 *   Particular -> horario marcado, de intervalo em intervalo
 *   Ambos      -> os dois (faixa antiga, sem marca, vale como "ambos")
 *
 * "Particular por encaixe": o particular tambem pode ser marcado em qualquer
 * horario livre do expediente da clinica, fora das faixas de convenio.
 *
 * Antes so a PRIMEIRA faixa do dia aparecia e salvar apagava as outras (a
 * sexta do Dr. Osmar tem Hapvida cedo e ligadura as 11h).
 */

const DIAS = [
  ['1', 'Segunda'],
  ['2', 'Terça'],
  ['3', 'Quarta'],
  ['4', 'Quinta'],
  ['5', 'Sexta'],
  ['6', 'Sábado'],
  ['0', 'Domingo']
];
const ATENDE = [
  ['convenio', 'Convênio'],
  ['particular', 'Particular'],
  ['ambos', 'Ambos']
];
const MAX_FAIXAS = 4;

export function JornadaEditor({ jornada, aoMudar }) {
  const dias = jornada?.dias ?? {};

  function mudarFaixas(dia, faixas) {
    const novos = { ...dias };
    if (faixas.length) novos[dia] = faixas;
    else delete novos[dia];
    aoMudar({ ...jornada, dias: novos });
  }
  const mudarFaixa = (dia, i, campo, valor) => mudarFaixas(dia, dias[dia].map((f, j) => (j === i ? { ...f, [campo]: valor } : f)));

  function novaFaixa(dia) {
    const ultima = dias[dia]?.at(-1);
    // A proxima comeca onde a anterior terminou (o caso comum: manha e tarde).
    const inicio = ultima?.fim ?? '08:00';
    const [h, m] = inicio.split(':').map(Number);
    const fim = `${String(Math.min(h + 2, 23)).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    mudarFaixas(dia, [...(dias[dia] ?? []), { inicio, fim, atende: 'particular' }]);
  }

  return (
    <div className="jornada2">
      <p className="jornada2__legenda">
        <span className="jornada2__tag jornada2__tag--convenio">Convênio</span> ordem de chegada a partir do início
        <span className="jornada2__sep" aria-hidden="true">·</span>
        <span className="jornada2__tag jornada2__tag--particular">Particular</span> horário marcado
      </p>

      <div className="jornada2__dias">
        {DIAS.map(([dia, nome]) => {
          const faixas = dias[dia] ?? [];
          const ativo = faixas.length > 0;
          return (
            <div key={dia} className={`jornada2__dia${ativo ? '' : ' jornada2__dia--folga'}`}>
              <label className="jornada2__nome">
                <input
                  type="checkbox"
                  checked={ativo}
                  onChange={(e) => mudarFaixas(dia, e.target.checked ? [{ inicio: '08:00', fim: '10:00', atende: 'convenio' }] : [])}
                />
                <span>{nome}</span>
              </label>

              {!ativo ? (
                <span className="jornada2__folga">Folga</span>
              ) : (
                <div className="jornada2__faixas">
                  {faixas.map((f, i) => {
                    const atende = f.atende ?? 'ambos';
                    return (
                      <div key={i} className="jornada2__faixa">
                        <Entrada type="time" aria-label={`${nome}, faixa ${i + 1}: início`} value={f.inicio} onChange={(e) => mudarFaixa(dia, i, 'inicio', e.target.value)} />
                        <span className="jornada2__ate" aria-hidden="true">–</span>
                        <Entrada type="time" aria-label={`${nome}, faixa ${i + 1}: fim`} value={f.fim} onChange={(e) => mudarFaixa(dia, i, 'fim', e.target.value)} />
                        <div className="jornada2__atende" role="radiogroup" aria-label={`${nome}, faixa ${i + 1}: atende`}>
                          {ATENDE.map(([v, r]) => (
                            <button
                              key={v}
                              type="button"
                              role="radio"
                              aria-checked={atende === v}
                              className={`jornada2__opcao jornada2__opcao--${v}${atende === v ? ' jornada2__opcao--sel' : ''}`}
                              onClick={() => mudarFaixa(dia, i, 'atende', v)}
                            >
                              {r}
                            </button>
                          ))}
                        </div>
                        <button
                          type="button"
                          className="jornada2__tirar"
                          aria-label={`Tirar a faixa ${i + 1} de ${nome}`}
                          title="Tirar esta faixa"
                          onClick={() => mudarFaixas(dia, faixas.filter((_, j) => j !== i))}
                        >
                          ×
                        </button>
                      </div>
                    );
                  })}
                  {faixas.length < MAX_FAIXAS && (
                    <button type="button" className="jornada2__mais" onClick={() => novaFaixa(dia)}>
                      + faixa
                    </button>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <label className="jornada2__encaixe">
        <input
          type="checkbox"
          checked={Boolean(jornada?.particularEncaixe)}
          onChange={(e) => aoMudar({ ...jornada, particularEncaixe: e.target.checked })}
        />
        <span>
          <strong>Particular por encaixe</strong>
          <small>
            Consulta particular também pode ser marcada em qualquer horário livre do expediente da clínica (Inteligência
            Artificial › Base de conhecimento › Horário), fora das faixas de convênio.
          </small>
        </span>
      </label>
    </div>
  );
}
